<template>
  <div style="padding: 10px">
    <!-- 搜索区域 -->
    <div style="margin: 10px 0">
      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
      <!-- 新增计算按钮 -->
      <el-button type="success" style="margin-left: 5px" @click="calculateTotals">计算</el-button>
      <el-button type="success" style="margin-left: 5px" @click="sendLegacy">一键送券</el-button>
    </div>

    <!-- 统计结果显示 -->
    <el-card v-if="showStatistics" style="margin-bottom: 20px">
      <div style="display: flex; justify-content: space-between;">
        <div>
          <h3>统计数据（基于当前列表）</h3>
          <p>统计条数: {{ statistics.count }} 条</p>
        </div>
        <div style="text-align: right;">
          <p>总支出: <span style="color: #f56c6c; font-weight: bold;">{{ statistics.totalExpense }}</span></p>
          <p>总收入: <span style="color: #67c23a; font-weight: bold;">{{ statistics.totalIncome }}</span></p>
          <p>净利润: <span style="color: #409eff; font-weight: bold;">{{ statistics.netProfit }}</span></p>
        </div>
        <div style="text-align: right;">
          <p>通行证支出: {{ statistics.txz }}</p>
          <p>购卡支出: {{ statistics.buyCard }}</p>
          <p>第一周宝库: {{ statistics.bkOne }}</p>
          <p>第二周宝库: {{ statistics.bkTwo }}</p>
          <p>第三周宝库: {{ statistics.bkThree }}</p>
          <p>第四周宝库: {{ statistics.bkFour }}</p>
        </div>
      </div>
    </el-card>

    <!-- 表格区域 -->
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="accountName"
          label="角色名"
          width="120"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="roleId"
          label="角色ID"
          width="120"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="legacyCount"
          label="残券数量"
          width="100"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="coin"
          label="咸鱼币数量"
          width="100"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="syncTime"
          label="同步时间"
          width="160"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="txz"
          label="通行证氪金"
          width="120"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="buyCard"
          label="购卡支出"
          width="120"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="bkOne"
          label="第一周宝库"
          width="120"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="bkTwo"
          label="第二周宝库"
          width="120"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="bkThree"
          label="第三周宝库"
          width="120"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="bkFour"
          label="第四周宝库"
          width="120"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="income"
          label="收入"
          width="120"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="status"
          label="状态"
          width="100"
          show-overflow-tooltip>
        <template #default="scope">
          <el-tag :type="getStatusTagType(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="vip"
          label="vip等级"
          width="100"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作" width="100px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 编辑表单 -->
    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="50%">
      <el-form :model="form" ref="formRef" :rules="rules" label-width="120px">
        <el-form-item label="残券数量" prop="legacyCount">
          <el-input-number v-model="form.legacyCount" :min="0" style="width: 100%"/>
        </el-form-item>

        <el-form-item label="通行证氪金" prop="txz">
          <el-input-number v-model="form.txz" :min="0" :precision="2" style="width: 100%"/>
        </el-form-item>

        <el-form-item label="购卡支出" prop="buyCard">
          <el-input-number v-model="form.buyCard" :min="0" :precision="2" style="width: 100%"/>
        </el-form-item>

        <el-form-item label="第一周宝库" prop="bkOne">
          <el-input-number v-model="form.bkOne" :min="0" :precision="2" style="width: 100%"/>
        </el-form-item>

        <el-form-item label="第二周宝库" prop="bkTwo">
          <el-input-number v-model="form.bkTwo" :min="0" :precision="2" style="width: 100%"/>
        </el-form-item>

        <el-form-item label="第三周宝库" prop="bkThree">
          <el-input-number v-model="form.bkThree" :min="0" :precision="2" style="width: 100%"/>
        </el-form-item>

        <el-form-item label="第四周宝库" prop="bkFour">
          <el-input-number v-model="form.bkFour" :min="0" :precision="2" style="width: 100%"/>
        </el-form-item>

        <el-form-item label="收入" prop="income">
          <el-input-number v-model="form.income" :min="0" :precision="2" style="width: 100%"/>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="vip等级" prop="vip">
          <el-input-number v-model="form.vip" :min="0" :max="20" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="咸鱼币数量" prop="vip">
          <el-input-number v-model="form.coin" :min="0" :max="20" style="width: 100%"/>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'LegacySoldManagement',
  components: {},
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '编辑',
      form: {
        id: '',
        legacyCount: 0,
        txz: 0,
        buyCard: 0,  // 新增字段
        bkOne: 0,
        bkTwo: 0,
        bkThree: 0,
        bkFour: 0,
        income: 0,
        status: 0,
        vip: 0
      },
      formRef: null,
      userId: '',
      loading: true,
      showStatistics: false,
      statistics: {
        count: 0,
        txz: 0,
        buyCard: 0,  // 新增字段
        bkOne: 0,
        bkTwo: 0,
        bkThree: 0,
        bkFour: 0,
        totalExpense: 0,
        totalIncome: 0,
        netProfit: 0
      },
      search: {},
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],

      // 表单验证规则
      rules: {
        legacyCount: [
          {required: true, message: '请输入残券数量', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ]
      },

      // 状态选项
      statusOptions: [
        {label: '正常', value: 0},
        {label: '停用', value: 1},
        {label: '删除', value: 2}
      ]
    }
  },
  created() {
    // 初始化用户信息
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;

    // 加载数据
    this.load();
  },
  methods: {
    // 重置搜索条件
    resetData() {
      this.search = {};
      this.currentPage = 1;
      this.load();
    },

    // 计算统计数据
    async calculateTotals() {
      try {
        this.loading = true;
        this.showStatistics = false;

        // 调用接口获取50条数据
        const res = await request.get("/legacySold/listPage", {
          params: {
            current: 1,
            size: 50
          }
        });

        if (res.code === '0') {
          let data = [];

          // 处理返回的数据结构
          if (Array.isArray(res.data)) {
            data = res.data;
          } else if (res.data && res.data.records) {
            data = res.data.records || [];
          } else if (res.data && res.data.list) {
            data = res.data.list || [];
          }

          // 计算统计数据
          this.calculateStatistics(data);
          this.showStatistics = true;

          this.$message({
            type: "success",
            message: `计算完成，共统计 ${data.length} 条数据`
          });
        } else {
          this.$message.error(res.msg || '计算失败');
        }
      } catch (error) {
        this.$message.error('网络错误，计算失败');
      } finally {
        this.loading = false;
      }
    },

    // 发送残券同步请求的方法
    sendLegacy() {
      this.loading = true;

      request.get("/xyzwws/websocket/legacySync")
          .then(res => {
            this.loading = false;
            if (res.code === '0') {
              this.$message({
                type: "success",
                message: res.msg || "同步请求发送成功"
              });
              // 可选：发送成功后刷新数据
              this.load();
            } else {
              this.$message({
                type: "error",
                message: res.msg || "同步请求发送失败"
              });
            }
          })
          .catch(error => {
            this.loading = false;
            console.error("同步请求错误:", error);
            this.$message.error("网络错误，同步请求失败");
          });
    },

    // 计算统计数据的具体逻辑
    calculateStatistics(data) {
      if (!data || data.length === 0) {
        this.resetStatistics();
        return;
      }

      let txz = 0;
      let buyCard = 0;  // 新增字段
      let bkOne = 0;
      let bkTwo = 0;
      let bkThree = 0;
      let bkFour = 0;
      let totalIncome = 0;

      data.forEach(item => {
        // 累加各项支出
        txz += parseFloat(item.txz || 0);
        buyCard += parseFloat(item.buyCard || 0);  // 新增字段
        bkOne += parseFloat(item.bkOne || 0);
        bkTwo += parseFloat(item.bkTwo || 0);
        bkThree += parseFloat(item.bkThree || 0);
        bkFour += parseFloat(item.bkFour || 0);

        // 累加收入
        totalIncome += parseFloat(item.income || 0);
      });

      // 计算总支出
      const totalExpense = txz + buyCard + bkOne + bkTwo + bkThree + bkFour;

      // 计算净利润
      const netProfit = totalIncome - totalExpense;

      // 更新统计数据
      this.statistics = {
        count: data.length,
        txz: this.formatNumber(txz),
        buyCard: this.formatNumber(buyCard),  // 新增字段
        bkOne: this.formatNumber(bkOne),
        bkTwo: this.formatNumber(bkTwo),
        bkThree: this.formatNumber(bkThree),
        bkFour: this.formatNumber(bkFour),
        totalExpense: this.formatNumber(totalExpense),
        totalIncome: this.formatNumber(totalIncome),
        netProfit: this.formatNumber(netProfit)
      };
    },

    // 重置统计数据
    resetStatistics() {
      this.statistics = {
        count: 0,
        txz: 0,
        buyCard: 0,  // 新增字段
        bkOne: 0,
        bkTwo: 0,
        bkThree: 0,
        bkFour: 0,
        totalExpense: 0,
        totalIncome: 0,
        netProfit: 0
      };
    },

    // 格式化数字，保留两位小数
    formatNumber(num) {
      return parseFloat(num.toFixed(2));
    },

    // 编辑按钮
    handleEdit(row) {
      this.dialogTitle = '编辑';
      this.form = {
        id: row.id,
        legacyCount: row.legacyCount || 0,
        txz: row.txz || 0,
        buyCard: row.buyCard || 0,  // 新增字段
        bkOne: row.bkOne || 0,
        bkTwo: row.bkTwo || 0,
        bkThree: row.bkThree || 0,
        bkFour: row.bkFour || 0,
        income: row.income || 0,
        status: row.status || 0,
        vip: row.vip || 0
      };
      this.dialogVisible = true;
    },

    // 保存（编辑）
    save() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;

          // 深拷贝表单数据
          const formData = JSON.parse(JSON.stringify(this.form));

          request.post("/legacySold/update", formData).then(res => {
            this.loading = false;
            if (res.code === '0') {
              this.$message({
                type: "success",
                message: res.msg || "编辑成功"
              });
              this.dialogVisible = false;
              this.load(); // 刷新数据
              // 如果显示统计，重新计算
              if (this.showStatistics) {
                this.calculateTotals();
              }
            } else {
              this.$message({
                type: "error",
                message: res.msg || "编辑失败"
              });
            }
          }).catch(error => {
            this.loading = false;
            this.$message.error("网络错误，编辑失败");
          });
        } else {
          return false;
        }
      });
    },

    // 加载数据
    load() {
      this.loading = true;

      // 构建查询参数
      const params = {
        current: this.currentPage,
        size: this.pageSize
      };

      // 添加搜索条件
      Object.keys(this.search).forEach(key => {
        if (this.search[key] !== '' && this.search[key] !== undefined && this.search[key] !== null) {
          params[key] = this.search[key];
        }
      });

      request.get("/legacySold/listPage", {
        params: params
      }).then(res => {
        this.loading = false;

        if (res.code === '0') {
          // 处理返回的数据结构
          let data = res.data;

          // 如果返回的是数组
          if (Array.isArray(data)) {
            this.tableData = data;
            this.total = data.length;
          }
          // 如果返回的是分页结构
          else if (data && data.records) {
            this.tableData = data.records || [];
            this.total = data.total || 0;
          }
          // 如果是对象但包含list
          else if (data && data.list) {
            this.tableData = data.list || [];
            this.total = data.total || 0;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error('网络错误，加载失败');
        this.tableData = [];
        this.total = 0;
      });
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      switch (parseInt(status)) {
        case 0:
          return 'success';
        case 1:
          return 'warning';
        case 2:
          return 'danger';
        default:
          return 'info';
      }
    },

    // 获取状态文本
    getStatusText(status) {
      const option = this.statusOptions.find(item => item.value === parseInt(status));
      return option ? option.label : '未知';
    },

    // 改变每页显示数量
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },

    // 改变当前页码
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    }
  }
}
</script>

<style scoped>
/* 可选的样式调整 */
.el-select {
  margin-right: 10px;
}

.el-table {
  margin-top: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: center;
}

/* 统计卡片样式 */
.el-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}

.el-card h3 {
  margin: 0 0 10px 0;
  color: #333;
}

.el-card p {
  margin: 5px 0;
  color: #666;
}
</style>
